import styled, {keyframes} from 'styled-components';
import {STICKY} from '../../../../../themes/css-global-classes';

const lobbyInfoKeyframes = keyframes`
    0%{
        transform: translate(0, 13rem);
    }
    25%{
        transform: translate(0, 15rem);
    }
    50%{
        transform: translate(0, 18rem);
    }
    100%{
        transform: translate(0, 22rem);
    }
`;

//.lobby-games-info
export const LobbyGameInfoDefaultBox = styled.div`
    position: absolute;
    right: 0;
    top: 0;
    width: 375px;
    margin-right: 2.5rem;
    

    &.${STICKY} {
        position: fixed;
        animation: ${lobbyInfoKeyframes} 0.5s ease-in-out forwards;
    }

    @media ${({theme}) => theme.mediaQuery.xlAndBelow} {
        width: 285px;
    }

`;
